import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 16px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content:center;
  align-items: center;
`;
